/** Demo / alpha: max patent rows rendered per portfolio in the sidebar (production would paginate or search). */
export const DEMO_PATENT_UI_LIMIT = 40;

/**
 * Claims / reader UI: prefer portfolio display name, keep document number visible.
 * When both: "Name · docId". When only doc: doc only.
 */
export function formatPatentDisplayCaption(displayName, documentNumber) {
  const name =
    displayName != null && String(displayName).trim() !== ""
      ? String(displayName).trim()
      : null;
  const doc =
    documentNumber != null && String(documentNumber).trim() !== ""
      ? String(documentNumber).trim()
      : null;
  if (name && doc) return `${name} · ${doc}`;
  if (name) return name;
  return doc || "—";
}

export function getMatchScore(score) {
  return Math.round((1 - parseFloat(score)) * 100);
}

export function getScoreStyles(score) {
  if (score >= 90) {
    return {
      background: "#E6F4EA",
      color: "#1B5E20",
    };
  }

  if (score >= 80) {
    return {
      background: "#FFF8E1",
      color: "#6D4C00",
    };
  }

  return {
    background: "#FDEDED",
    color: "#8E1B1B",
  };
}
